import {
  createRedoCustomerRpcClient,
  RedoCustomerRpcClient,
} from "@redotech/redo-merchant-customer-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoCustomerRpcClientContext: Context<
  RedoCustomerRpcClient | undefined
> = createContext<RedoCustomerRpcClient | undefined>(undefined);
RedoCustomerRpcClientContext.displayName = "RedoCustomerRpcClientContext";

export function RedoCustomerRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoCustomerRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoCustomerRpcClient({
      baseURL: new URL(`${baseUrl}/customer-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoCustomerRpcClientContext.Provider value={redoCustomerRpcClient}>
      {children}
    </RedoCustomerRpcClientContext.Provider>
  );
}
